{
  "ATTRIBUTES_MGMT": {
    "HEADER": "Attributi personalizzati",
    "HEADER_BTN_TXT": "Aggiungi attributo personalizzato",
    "LOADING": "Recupero degli attributi personalizzati",
    "DESCRIPTION": "A custom attribute tracks additional details about your contacts or conversations—such as the subscription plan or the date of their first purchase. You can add different types of custom attributes, such as text, lists, or numbers, to capture the specific information you need.",
    "LEARN_MORE": "Learn more about custom attributes",
    "ATTRIBUTE_TYPES": {
      "TEXT": "Testo",
      "NUMBER": "Numero",
      "LINK": "Link",
      "DATE": "Data",
      "LIST": "Elenco",
      "CHECKBOX": "Casella di controllo",
      "TEXT_AREA": "Area di testo"
    },
    "ADD": {
      "TITLE": "Aggiungi attributo personalizzato",
      "SUBMIT": "Crea",
      "CANCEL_BUTTON_TEXT": "Annulla",
      "FORM": {
        "NAME": {
          "LABEL": "Nome visualizzato",
          "PLACEHOLDER": "Inserisci il nome di visualizzazione dell'attributo personalizzato",
          "ERROR": "Il nome è obbligatorio"
        },
        "DESC": {
          "LABEL": "Descrizione",
          "PLACEHOLDER": "Inserisci una descrizione dell'attributo personalizzato",
          "ERROR": "La descrizione è obbligatoria"
        },
        "MODEL": {
          "LABEL": "Si applica a",
          "PLACEHOLDER": "Si prega di selezionarne uno",
          "ERROR": "Il modello è obbligatorio"
        },
        "TYPE": {
          "LABEL": "Tipo",
          "PLACEHOLDER": "Seleziona un tipo",
          "ERROR": "Il tipo è obbligatorio",
          "LIST": {
            "LABEL": "Elenco valori",
            "PLACEHOLDER": "Inserisci il valore e premi il tasto Invio",
            "ERROR": "Deve avere almeno un valore"
          }
        },
        "KEY": {
          "LABEL": "Chiave",
          "PLACEHOLDER": "Inserisci la chiave dell'attributo personalizzato",
          "ERROR": "La chiave è obbligatoria",
          "IN_VALID": "Chiave non valida"
        },
        "REGEX_PATTERN": {
          "LABEL": "Regex Pattern",
          "PLACEHOLDER": "Please enter custom attribute regex pattern. (Optional)"
        },
        "REGEX_CUE": {
          "LABEL": "Regex Cue",
          "PLACEHOLDER": "Please enter regex pattern hint. (Optional)"
        },
        "ENABLE_REGEX": {
          "LABEL": "Enable regex validation"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Attributo personalizzato aggiunto con successo!",
        "ERROR_MESSAGE": "Could not create a Custom Attribute. Please try again later."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Elimina",
      "API": {
        "SUCCESS_MESSAGE": "Attributo personalizzato eliminato con successo.",
        "ERROR_MESSAGE": "Impossibile eliminare l'attributo personalizzato. Riprova."
      },
      "CONFIRM": {
        "TITLE": "Sei sicuro di voler eliminare - {attributeName}",
        "PLACE_HOLDER": "Digita {attributeName} per confermare",
        "MESSAGE": "L'eliminazione rimuoverà l'attributo personalizzato",
        "YES": "Elimina ",
        "NO": "Annulla"
      }
    },
    "EDIT": {
      "TITLE": "Modifica attributo personalizzato",
      "UPDATE_BUTTON_TEXT": "Aggiorna",
      "TYPE": {
        "LIST": {
          "LABEL": "Elenco valori",
          "PLACEHOLDER": "Inserire i valori e premere il tasto Invio"
        }
      },
      "API": {
        "SUCCESS_MESSAGE": "Attributo personalizzato aggiornato con successo",
        "ERROR_MESSAGE": "Si è verificato un errore durante l'aggiornamento dell'attributo personalizzato, si prega di riprovare"
      }
    },
    "TABS": {
      "HEADER": "Attributi personalizzati",
      "CONVERSATION": "Conversazioni",
      "CONTACT": "Contatto"
    },
    "LIST": {
      "TABLE_HEADER": {
        "NAME": "Nome",
        "DESCRIPTION": "Descrizione",
        "TYPE": "Tipo",
        "KEY": "Chiave"
      },
      "BUTTONS": {
        "EDIT": "Modifica",
        "DELETE": "Elimina"
      },
      "EMPTY_RESULT": {
        "404": "Non ci sono attributi personalizzati creati",
        "NOT_FOUND": "Non ci sono attributi personalizzati configurati"
      },
      "REGEX_PATTERN": {
        "LABEL": "Regex Pattern",
        "PLACEHOLDER": "Please enter custom attribute regex pattern. (Optional)"
      },
      "REGEX_CUE": {
        "LABEL": "Regex Cue",
        "PLACEHOLDER": "Please enter regex pattern hint. (Optional)"
      },
      "ENABLE_REGEX": {
        "LABEL": "Enable regex validation"
      }
    }
  }
}
